import { render, staticRenderFns } from "./AlignTopRight.vue?vue&type=template&id=d51ab622&scoped=true&"
import script from "./AlignTopRight.vue?vue&type=script&lang=js&"
export * from "./AlignTopRight.vue?vue&type=script&lang=js&"
import style0 from "./AlignTopRight.vue?vue&type=style&index=0&id=d51ab622&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d51ab622",
  null
  
)

export default component.exports